let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4vv1Q")).then(() => parcelRequire('g4KKw'));